<template>
    <div>
        <nav class="navbar fixed-top navbar-dark navbar-expand-lg bg-dark">
            <div class="container" :class="{'justify-content-end': platform == 'mobile'}">
                <template v-if="platform == 'desktop'">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item">
                            <template  v-if="!block">
                                <div class="dropdown">
                                    <a href="javascript:;" class="nav-link dropdown-toggle" :class="{'active': page_current == 'dashboard'}" id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-fire mr-2"></i>Eventos
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownMenu">
                                        <router-link to="/dashboard" class="dropdown-item" :class="{'active': page_current == 'dashboard'}">Pré-jogo</router-link>
                                        <a class="dropdown-item" href="javascript:;" @click="modalLive">Ao vivo</a>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <router-link to="/dashboard" class="nav-link" :class="{'active': page_current == 'dashboard'}"><i class="fas fa-fire mr-2"></i>Eventos</router-link>
                            </template>
                        </li>
                        <li class="nav-item">
                            <router-link to="/dashboard/leagues" class="nav-link" :class="{'active': page_current == 'leagues'}"><i class="fas fa-trophy mr-2"></i>Ligas</router-link>
                        </li>
                        <li class="nav-item">
                            <div class="dropdown">
                                <a href="javascript:;" class="nav-link dropdown-toggle" id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-plus mr-2"></i>Adicionar
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu">
                                    <router-link to="/dashboard/league" class="dropdown-item" :class="{'active': page_current == 'league'}">Liga</router-link>
                                    <router-link to="/dashboard/event" class="dropdown-item" :class="{'active': page_current == 'event'}">Evento</router-link>
                                    <div class="dropdown-divider"></div>
                                    <router-link to="/dashboard/client" class="dropdown-item" :class="{'active': page_current == 'client', 'disabled': block}">Cliente</router-link>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item">
                            <router-link to="/dashboard/clients" class="nav-link" :class="{'active': page_current == 'clients', 'disabled': block}"><i class="fas fa-users mr-2"></i>Clientes</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/dashboard/results" class="nav-link" :class="{'active': page_current == 'results'}"><i class="fas fa-poll-h mr-2"></i>Resultados</router-link>
                        </li>
                    </ul>
                    <button class="btn btn-danger mr-2" @click="correctEventDialog" v-if="!block">
                        <i class="fas fa-tools mr-2"></i>Corrigir evento
                    </button>
                    <button class="btn btn-outline-warning my-2 my-sm-0" @click="logout">
                        <i class="fas fa-sign-out-alt mr-2"></i>Sair
                    </button>
                </template>
                <template v-else>
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item">
                            <template  v-if="!block">
                                <div class="dropdown">
                                    <a href="javascript:;" class="nav-link dropdown-toggle" :class="{'active': page_current == 'dashboard'}" id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-fire mr-2"></i>Eventos
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownMenu">
                                        <router-link to="/dashboard" class="dropdown-item" :class="{'active': page_current == 'dashboard'}">Pré-jogo</router-link>
                                        <a class="dropdown-item" href="javascript:;" @click="modalLive">Ao vivo</a>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <router-link to="/dashboard" class="nav-link" :class="{'active': page_current == 'dashboard'}"><i class="fas fa-fire mr-2"></i>Eventos</router-link>
                            </template>
                        </li>
                    </ul>
                    <div class="dropdown-menu-right">
                        <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-bars"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                            <router-link to="/dashboard" class="dropdown-item" :class="{'active': page_current == 'dashboard'}"><i class="fas fa-fire mr-2"></i>Eventos</router-link>
                            <router-link to="/dashboard/leagues" class="dropdown-item" :class="{'active': page_current == 'leagues'}"><i class="fas fa-trophy mr-2"></i>Ligas</router-link>
                            <router-link to="/dashboard/clients" class="dropdown-item" :class="{'active': page_current == 'clients', 'disabled': block}"><i class="fas fa-users mr-2"></i>Clientes</router-link>
                            <router-link to="/dashboard/results" class="dropdown-item" :class="{'active': page_current == 'results'}"><i class="fas fa-poll-h mr-2"></i>Resultados</router-link>
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-header text-uppercase text-center">Adicionar</div>
                            <div class="dropdown-divider"></div>
                            <router-link to="/dashboard/league" class="dropdown-item" :class="{'active': page_current == 'league'}"><i class="fas fa-plus mr-2"></i>Liga</router-link>
                            <router-link to="/dashboard/event" class="dropdown-item" :class="{'active': page_current == 'event'}"><i class="fas fa-plus mr-2"></i>Evento</router-link>
                            <router-link to="/dashboard/client" class="dropdown-item" :class="{'active': page_current == 'client', 'disabled': block}"><i class="fas fa-plus mr-2"></i>Cliente</router-link>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="javascript:;" @click="correctEventDialog" v-if="!block"><i class="fas fa-tools mr-2"></i>Corrigir evento</a>
                            <a class="dropdown-item" href="javascript:;" @click="logout"><i class="fas fa-sign-out-alt mr-2"></i>Sair</a>
                        </div>
                    </div>
                </template>
            </div>
        </nav>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </div>
</template>

<script>
import {api} from '../api'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            block: true,
            loading: false,
            page_current: document.location.pathname.split('/').pop(),
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Loading
    },
    methods: {
        logout() {
            this.removeItem('token').then(() => {
                this.removeItem('auth').then(() => {
                    window.location.reload();
                });
            })
        },
        async correctEventDialog() {

            try {

                const { value: formValues } = await Swal.fire({
                    title: 'Corrigir evento',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    html: `
                        <label class="d-block text-left mb-0" for="swal-input2">Tipo de correção</label>
                        <select id="swal-input2" class="swal2-input w-100">
                            <option value="1">Resultado</option>
                            <option value="2">Cotação errada</option>
                            <option value="3">Corrigir ID do evento</option>
                            <option value="4">Excluir eventos adiados e cancelados</option>
                            <option value="5">Ativa/Desativar mercados ao vivo e id</option>
                        </select>
                    `,
                    focusConfirm: false,
                    preConfirm: () => {
                        return {
                            tipo: document.getElementById('swal-input2').value
                        }
                    }
                });

                if (!formValues) {
                    return;
                } else if (formValues.tipo == 1) {
                    this.fixEvent();
                } else if (formValues.tipo == 2) {
                    this.$router.push('/dashboard/correct-event');
                } else if (formValues.tipo == 3) {
                    this.$router.push('/dashboard/correct-id-event');
                } else if (formValues.tipo == 5) {
                    this.$router.push('/dashboard/live-params');
                } else {
                    this.deleteEventsAll();
                }
            } 
            catch(e) 
            {
                Swal.fire(
                    'Falha!',
                    'Ocorreu um erro, atualize a página!',
                    'error'
                );
            }
        },
        deleteEventsAll() {

            const self = this;

            Swal.fire({
                title: 'Confirmação',
                html: 'Você deseja mesmo excluir os eventos adiados e cancelados?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim'
            }).then((result) => {

                if (result.value) {

                    self.loading = true;

                    api.delete('delete-all-events').then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                Swal.fire(
                                    'Parabéns!',
                                    `Foi excluído um total de (<strong>${response.data.total}</strong>) eventos adiados e cancelados!`,
                                    'success'
                                );
                            break;
                            default:
                                Swal.fire(
                                    'Atenção',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            });
        },
        async fixEvent() {

            try {

                const self = this;

                const { value: formValues } = await Swal.fire({
                    title: 'Corrigir evento',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    html: `
                        <label class="d-block text-left mb-0" for="swal-input2">Clientes</label>
                        <select id="swal-input2" class="swal2-input w-100">
                            <option value="1">Todos</option>
                            <option value="2">Selecionar</option>
                        </select>
                    `,
                    focusConfirm: false,
                    preConfirm: () => {
                        return {
                            tipo: document.getElementById('swal-input2').value
                        }
                    }
                });

                if (!formValues) {
                    return;
                } else if (formValues.tipo == 1) {
                    self.correctEvents();
                } else if (formValues.tipo == 2) {
                    self.$router.push('/dashboard/fix-event');
                }
            } 
            catch(e) 
            {
                Swal.fire(
                    'Falha!',
                    'Ocorreu um erro, atualize a página!',
                    'error'
                );
            }
        },
        async correctEvents() {

            try {
                
                const self = this;
                
                const { value: id } = await Swal.fire({
                    title: 'Recorrigir evento',
                    html: 'Informe o ID do evento',
                    input: 'text',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    customClass: 'sweet-only-custom',
                    inputPlaceholder: 'Informe o ID do evento',
                    confirmButtonText: 'Corrigir',
                    inputValidator: (value) => {

                        if (!value) {
                            return 'Informe o ID do evento!'
                        } else if (!value.match(/^[0-9a-fA-F]{24}$/)) {
                            return 'O ID informado é inválido!'
                        }
                    }
                });

                if (id) {
                    
                    self.loading = true;

                    api.get(`betting-correction/${id}`).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                self.report(response.data.results);
                            break;
                            default: 
                                Swal.fire(
                                    'Atenção',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            } 
            catch(e) 
            {
                Swal.fire(
                    'Falha!',
                    'Ocorreu um erro, atualize a página!',
                    'error'
                );
            }
        },
        modalLive() {

            const self = this;

            Swal.fire({
                title: 'Eventos ao vivo',
                html: 'Aguarde... <br /> Esse processo pode demorar um pouco.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showConfirmButton: false,
                showCancelButton: false,
                onBeforeOpen: () => {
                    Swal.showLoading()
                }
            });

            api.get('inplay').then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.modalLiveOpen(response.data.events);
                    break;
                    default:
                        Swal.fire(
                            'Atenção!',
                            response.data.message,
                            'warning'
                        );
                    break;
                }
            }).catch((error) => {
                try {
                    Swal.fire(
                        'Falha',
                        self.network_erros[error.status]['message'],
                        'error'
                    );
                } catch(e) {
                    Swal.fire(
                        'Falha',
                        self.network_erros[408]['message'],
                        'error'
                    );
                }
            });
        },
        modalLiveOpen(jogos) {

            // Ordena os jogos por nome do campeonato (league)
    const jogosOrdenados = [...jogos].sort((a, b) =>
      a.league.localeCompare(b.league, 'pt', { sensitivity: 'base' })
    );

Swal.fire({
      title: `Jogos (${jogos.length})`,
      html: `
        <input type="text" id="busca" class="form-control mb-3" placeholder="Buscar por time ou campeonato">
        <div id="lista-jogos">${this.renderizarJogos(jogosOrdenados)}</div>
      `,
      width: this.platform == 'desktop' ? '50%' : '95%',
      showCloseButton: true,
      showConfirmButton: false,
      onRender: () => {
        const input = Swal.getPopup().querySelector('#busca');
        input.addEventListener("input", () => {
          const termo = this.normalizarTexto(input.value);
          const filtrados = jogosOrdenados.filter(jogo =>
            this.normalizarTexto(jogo.league).includes(termo) ||
            this.normalizarTexto(jogo.team_home).includes(termo) ||
            this.normalizarTexto(jogo.team_away).includes(termo)
          );

          Swal.getPopup().querySelector("#lista-jogos").innerHTML = this.renderizarJogos(filtrados);
        });
      }
    });

        },
        normalizarTexto(texto) {
    return texto
      .toLowerCase()
      .normalize("NFD") // separa acentos
      .replace(/[\u0300-\u036f]/g, "") // remove acentos
      .replace(/[^a-z0-9\s]/g, ""); // remove caracteres especiais
  },
        renderizarJogos(lista) {

if (lista.length === 0) {
      return `<div class="alert alert-warning text-center">Nenhum jogo encontrado</div>`;
    }

    // Ordena por nome do campeonato
    const ordenados = [...lista].sort((a, b) =>
      a.league.localeCompare(b.league, 'pt', { sensitivity: 'base' })
    );

    // Agrupa por campeonato
    const grupos = {};
    ordenados.forEach(jogo => {
      if (!grupos[jogo.league]) {
        grupos[jogo.league] = [];
      }
      grupos[jogo.league].push(jogo);
    });

    let html = '<div class="container-fluid">';
    for (const campeonato in grupos) {
      html += `
        <h5 class="bg-primary text-white p-2 rounded text-truncate mb-2">${campeonato}</h5>
      `;
      grupos[campeonato].forEach(jogo => {
        html += `
          <div class="card shadow-sm mb-2">
            <div class="card-body p-2">
              <h6 class="card-title text-center mb-2">
                <div class="d-flex justify-content-between">
                  <span class="text-truncate text-end flex-fill">${jogo.team_home}</span>
                  <span class="mx-2">vs</span>
                  <span class="text-truncate text-start flex-fill">${jogo.team_away}</span>
                </div>
              </h6>
              <p class="card-text small mb-1">
                <strong>Tempo:</strong> ${jogo.period} (${jogo.timer}')<br>
                <strong>Placar:</strong> ${jogo.score}<br>
                <strong>ID:</strong> ${jogo.id}<br>
                <strong>Cartões:</strong> ${jogo.stats.cartoes}<br>
                <strong>Escanteios:</strong> ${jogo.stats.escanteios}
              </p>
            </div>
          </div>
        `;
      });
    }
    html += '</div>';
    return html;

        },
        removeItem(key) {
            return Promise.resolve().then(() => {
                window.localStorage.removeItem(key);
            });
        },
        report(results) {
            
            let html = '';
            let count = 0;

            for (const item of results) {
                html += `
                    <div class="row pb-3 border-bottom ${count > 0 ? 'pt-3' : ''}">
                        <div class="col text-truncate">${item.cliente}</div>
                        <div class="col text-truncate ${(item.message.includes('erro') || item.message.includes('failed')) ? 'text-danger' : 'text-success'}">${item.message}</div>
                    </div>
                `; count++;
            }

            Swal.fire(
                `Relatório (${count})`,
                html
            );
        },
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.platform = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
        });
    },
    beforeMount() {
        try {

            const {pipe} = JSON.parse(localStorage.getItem('auth'));

            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    }
}
</script>

<style scoped>
.dropdown-toggle::after {
    display: none!important;
}
</style>